import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** "Needs attention" indicator — soft pulsing fill drives the eye to
 *  unmet validation rules. Pause via `active=false` once everything
 *  passes (the meter swaps to IcnCheck at success tone). */
export function IcnAlert(props: AnimatedIconProps): ReactNode {
  const { active = true, ...rest } = props;
  const animate = useDecorativeIconMotion(active);
  return (
    <Svg {...rest} iconName="alert" data-on={active ? 'true' : 'false'}>
      <circle cx="8" cy="8" r="6" fill="currentColor" stroke="none" opacity="0.16">
        {animate && (
          <animate
            attributeName="opacity"
            values="0.12;0.32;0.12"
            dur="1.6s"
            repeatCount="indefinite"
          />
        )}
      </circle>
      <circle cx="8" cy="8" r="6" />
      <path d="M8 4.5v4" />
      <circle cx="8" cy="11" r="0.7" fill="currentColor" stroke="none" />
    </Svg>
  );
}
